// Days until / color for DOT permit expiration dates.
export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(`${dateStr}T00:00:00`);
  if (isNaN(d.getTime())) return null;
  return Math.round((d - today) / 86400000);
}

// Scarlet within 7 days (or expired), amber within 30 days, otherwise normal (undefined = inherit).
export function expirationColor(dateStr) {
  const days = daysUntil(dateStr);
  if (days === null) return undefined;
  if (days <= 7) return '#E5441A';
  if (days <= 30) return '#D97706';
  return undefined;
}
